module.exports = __webpack_public_path__ + "static/img/yonghu1.52a329f6.png";